export default "__VITE_ASSET__BQpohcrY__"